import * as React from "react"
import { Routes, Route } from "react-router-dom"

import './styles/css/App.css'
import PrivateRoutes from "./pages/PrivateRoutes"
import Header from "./pages/Header"
import Login from "./pages/Login"
import SignUp from "./pages/Signup"
import Logout from "./pages/Logout"
import ProfilePage from "./pages/ProfilePage"
import ForgotPassword from "./pages/ForgotPassword"
import VerificationEmail from "./pages/VerificationEmail"
import PasswordReset from "./pages/PasswordReset"
import AdminPage from './pages/Admin'
import StandaloneViewer from "./pages/StandaloneViewer"
import NotFound from './pages/NotFound'
import ReportV2 from './pages/ReportV2'
import ClusterExpt from "./pages/ClusterExpt"
import Dashboardv2 from "./pages/DashBoardv2"
import Test from "./pages/Test"
import { isPrivate } from './utils/config'
import PerformanceDashboard from "./component/common/performanceDash"
import Chat from "./pages/Chat"
import Patients from "./pages/Patients"
import SimpleDashboard from "./pages/SimpleDashboard"
import StandaloneViewerV2 from "./pages/StandaloneViewerV2"

console.log("%c(o_o) This is a browser feature intended for developers.", "color: red")

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route element={<Header />}>
          <Route element={<PrivateRoutes />}>
            <Route path="/" element={<Dashboardv2 />} />
            <Route path="/home" element={<SimpleDashboard />} />
            <Route path="/dashboard" element={<Dashboardv2 />} />
            <Route path="/patients" element={<Patients />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/admin" element={<AdminPage />} />
            {isPrivate && <Route path="/cluster-expt" element={<ClusterExpt />} />}
            <Route path="/chat/:imageId" element={<Chat />} />
            {isPrivate && <Route path="/perfomon" element={<PerformanceDashboard />} />}
          </Route>
          <Route path="/viewer/:imageId" element={<StandaloneViewer />} />
          <Route path="/viewer-v2/:imageId" element={<StandaloneViewerV2 />} />
        </Route>
        <Route path="/report/:imageId/" element={<ReportV2 />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route path="/test" element={<Test />} />
        <Route path="/activation/:uniqueToken" element={<VerificationEmail />} />
        <Route path="/reset/:uniqueToken" element={<PasswordReset />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  )
}
